/* eslint-disable import/prefer-default-export */
import { useEffect, useState } from 'react';
import { Drawer } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { setDrawer } from '../redux/actions/drawerActions';
import {
  CLOSE_ICON, ClientListIcon, EMPTY_PROFILE_PIC, LogoutIcon, PrismLogo
} from '../utilities/generatedClasses';
import { overlayTopSide, unOverlayTopSide } from '../utilities/utils';
import GeneralAccess from '../dataAccess/GeneralAccess';

import ClientAccess from '../dataAccess/ClientAccess';
import { useMsal } from '@azure/msal-react';
import feedbackImg from '../assets/images/feedback.png';

export const CustomDrawer = () => {
  const drawerAction = useSelector(state => state.drawer);
  const [userName, setUserName] = useState(null);
  const [userProfileImage, setUserProfileImage] = useState('');
  const [isClientTabAvailable, showClientTab] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  
  const [FirstName, setFirstName] = useState('');
  const [LastName, setLastName] = useState('');
   const { instance, accounts } = useMsal();
  useEffect(() => {
    ClientAccess.getUserSetup().then((response) => {
      if(response && response.data && response.data.length > 0){
        const userSetup = response.data[0];
        if(userSetup){
          setUserName(userSetup.UserName)
          setUserProfileImage(userSetup.UserProfileImage)
          setFirstName(userSetup.UserName.split(' ')[0]);
          setLastName(userSetup.UserName.split(' ')[1]);
        } else {
          setUserName('User Profile');
        }
      }
    })
  }, []);

  useEffect(() => {
    if (location.pathname !== '/home/editprofile' && location.pathname !== '/home' && location.pathname !== '/home/paymentsubmission') {
      showClientTab(true);
    } else {
      showClientTab(false);
    }
  }, [location]);

  const toggleDrawer = (open) => {
    if (open === false) {
      unOverlayTopSide();
    } else {
      overlayTopSide();
    }
    dispatch(setDrawer(open));
  };

  const logoutUser = () => {
    localStorage.clear();
    sessionStorage.clear();

    instance.logoutRedirect({
      account: accounts[0],
      postLogoutRedirectUri: "/",
    });
    toggleDrawer(false);
  };

  const goToClientList = () => {
    if (isClientTabAvailable) {
      navigate('/home/clientlist');
      toggleDrawer(false);
    }
  };

    const goToFeedbacks = () => {
      navigate('/home/feedbacks?firstName=' + FirstName + '&lastName=' + LastName);
      toggleDrawer(false);
  };

  const goToUserProfile = () => {
    if (location.pathname === '/home/editprofile') {
      navigate(-1);
    } else {
      navigate('/home/userprofile');
    }
    toggleDrawer(false);
  };

  return (
    <Drawer
      anchor="left"
      open={drawerAction}
      onClose={() => toggleDrawer(false)}
      >
      <div className="drawer">
        <div aria-hidden className="close-icon-container" onClick={() => toggleDrawer(false)}>
          <div className={`${CLOSE_ICON} size-20`} />
        </div>
        <div>
          <div className="row-flex align-center onProfileHover" aria-hidden onClick={() => goToUserProfile()}>

            <div className="drawer-icon-profile-container">
              {userProfileImage &&
              <img src={userProfileImage} style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '50%'}} alt="User Profile" />
              
              }
              {!userProfileImage &&
                <div className={`${EMPTY_PROFILE_PIC} drawer-icon-profile`} />
              
              }
            </div>

            <label className="user-profile-name">{userName}</label>
          </div>
        </div>

        <div style={{
          padding: '20px 0',
          height: '100%',
          opacity: isClientTabAvailable ? 1 : 0,
          cursor: isClientTabAvailable ? 'pointer' : 'default'
        }}>
          <div aria-hidden className="drawer-padding-margin row-flex align-center" onClick={goToClientList}>
            <div className={`${ClientListIcon} drawer-icon-text`} />
            <label>Client List</label>
          </div>
           <div aria-hidden className="drawer-padding-margin row-flex align-center" onClick={goToFeedbacks}>
             <img src={feedbackImg} className="drawer-icon-text"/>
            <label>Feedback</label>

          </div>
        </div>
        <div aria-hidden className="padding-row-logout align-center" onClick={logoutUser}>
          <div className={`${LogoutIcon} drawer-icon-text`} />
          <label>Log Out</label>
        </div>
        <div
          className={PrismLogo}
          style={{ width: '75%', height: '60px', margin: 'auto', paddingBottom: '50px' }} />
      </div>
    </Drawer>
  );
};
